import {
  SPI,
  FormFieldWidget,
  ViewType,
  ModelFieldType,
  FormM2MFieldSelectWidget,
  Widget,
  isEmptyValue,
  BaseFieldOptions,
  ConditionBuilder,
  deepClone,
  filterRsql
} from '@kunlun/dependencies';
import Comp from './SelectWidget.vue';
import { isNil } from 'lodash-es';

const genToken = (name: string, model: string[]) => {
  return {
    viewType: ViewType.Search,
    name,
    model,
    ttype: ModelFieldType.ManyToOne,
    multi: false,
    widget: 'Select'
  } as BaseFieldOptions;
};

@SPI.ClassFactory(FormFieldWidget.Token(genToken('buyerPartner', ['deli.aries.seller.SellerDistributorTradeOrder'])))
@SPI.ClassFactory(
  FormFieldWidget.Token(
    genToken('salesOffice', [
      'deli.aries.seller.SellerDistributorTradeOrder',
      'deli.aries.seller.SellerDistributionTradeOrderDetail',
      'deli.aries.seller.SellerDistributorTmsOrder',
      'deli.aries.trade.DeliAriesPlatformBrandStoreTradeOrderDetail'
    ])
  )
)
@SPI.ClassFactory(
    FormFieldWidget.Token(
        genToken('salesOrganization', [
          'deli.aries.trade.DeliAriesPlatformBrandStoreTradeOrderDetail'
        ])
    )
)
@SPI.ClassFactory(
    FormFieldWidget.Token(
        genToken('kailasCompanySeller', [
          'deli.aries.trade.DeliAriesPlatformBrandStoreTradeOrderDetail'
        ])
    )
)
@SPI.ClassFactory(
    FormFieldWidget.Token(
        genToken('kailasCompanyBuyer', [
          'deli.aries.trade.DeliAriesPlatformBrandStoreTradeOrderDetail'
        ])
    )
)
export class SearchM2OMultiSelectWidget extends FormM2MFieldSelectWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(Comp);
    return this;
  }

  @Widget.Watch('value', { deep: true })
  protected watchValue() {
    this.selectedValues = this.value as any;
    if (!isEmptyValue(this.value)) {
      if (this.dataList && this.dataList.length) {
        this.fillOptions(this.dataList);
      }
    } else {
      if (this.oldDomain && this.oldDomain !== this.domain) {
        // 解决其他字段联动后当前字段domain发生了改变，且配置了clearFields清空了当前字段value的时候，之前已选中的对象还在options的问题
        // 之前watch domain 属性是没有用的，domain发生改变的时候value还是老的数据，所以需要在domain和value同时明确发生改变后重新获取一次options
        this.currentPage = 1;
        this.initLoadOptions();
        this.oldDomain = '';
      }
    }
  }
  @Widget.Method()
  protected async search(searchValue: string, forceSearch = false) {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    if (!forceSearch) {
      if (this.searchValue === searchValue) {
        return;
      }
    }
    this.searchValue = searchValue;
    if (typeof this.searchValue === 'string') {
      this.searchValue = this.searchValue.trim()
    }
    this.currentPage = 1;
    this.timeout = setTimeout(delaySearch, 400);

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;

    async function delaySearch() {
      const iQueryPageResult = await self.loadOptions({
        condition: builderSelectSearchCondition(self.queryFieldName, self.searchValue, self.domain),
        currentPage: self.currentPage
      });
      if (iQueryPageResult) {
        self.totalPages = getRealPages(iQueryPageResult.totalPages);
        await self.fillOptions(iQueryPageResult.content, false);
      }
    }
  }
}
function getRealPages(val) {
  return isNil(val) ? 1000 : val;
}
const conditionBuilder = ConditionBuilder.getInstance();
const builderSelectSearchCondition = (searchFieldName: string, searchValue: string, domain?: string): string => {
  const realSearchValue = deepClone(filterRsql(searchValue));
  const searchStr = !realSearchValue
    ? '1==1'
    : searchFieldName
        .split(',')
        .map((item) => {
          const condition = conditionBuilder.condition(item).equal(`${realSearchValue}`);
          return condition.toString();
        })
        .join(' or ');
  const condition = domain
    ? conditionBuilder.condition(searchStr).and(conditionBuilder.condition(domain)).toString()
    : searchStr;
  return condition;
};
